import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { compose, lifecycle } from "recompose";
import { isAuthenticated } from "../selectors";
import { unauthenticationRedirect } from "../actions";

export default Component =>
  compose(
    withRouter,
    connect(
      createStructuredSelector({
        isAuthenticated
      }),
      {
        redirect: unauthenticationRedirect
      }
    ),
    lifecycle({
      componentDidMount() {
        if (!this.props.isAuthenticated) {
          const { pathname } = document.location;
          const shouldRedirect = pathname !== "/" && !!pathname;

          this.props.redirect(
            this.props.location.pathname,
            shouldRedirect && pathname
          );
        }
      }
    })
  )(props => (props.isAuthenticated ? <Component {...props} /> : null));



// WEBPACK FOOTER //
// ./src/modules/user/auth/hoc/authenticated.js